import { ChatWall } from "../components/ChatWall";
import { useApp } from "../context/AppContext";
import { PageHead } from "./Explore";
import { TopTraders } from "../components/TopTraders";
import { Panel } from "../components/State";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ShieldCheck, Search, Users, ShieldBan } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { MemberRow } from "../components/Members";
import { Link } from "react-router-dom";
import { Loading, Empty } from "../components/State";

const MemberSearch = () => {
  const { social } = useApp();
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/members/search", { params: { q } }).then((r) => setRes(r.data)).catch(() => setRes([])), 300);
    return () => clearTimeout(t);
  }, [q, social]);
  return (
    <Panel title="Find members" icon={Search} testid="member-search-panel">
      <div className="p-4"><input data-testid="member-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by nickname or wallet address" className="field" /></div>
      <div className="px-2 pb-3" data-testid="member-search-results">{res === null ? <Loading /> : !res.length ? <Empty title="No members found" /> : res.map((m) => <MemberRow key={m.address} m={m} />)}</div>
    </Panel>
  );
};

const MyNetwork = () => {
  const { user, social } = useApp();
  const [d, setD] = useState(null);
  useEffect(() => { user && api.get("/social").then((r) => setD(r.data)).catch(() => setD({ friends: [], blocked: [] })); }, [user, social]);
  if (!user) return <Panel><Empty title="Connect your wallet to manage friends and blocked members" /></Panel>;
  if (!d) return <Loading />;
  return (
    <div className="grid lg:grid-cols-2 gap-5">
      <Panel title={`Friends (${d.friends.length})`} icon={Users} testid="friends-list">
        <div className="px-2 py-2">{!d.friends.length ? <Empty title="No friends yet" hint="Find members and tap Add friend." /> : d.friends.map((m) => <MemberRow key={m.address} m={m} />)}</div>
      </Panel>
      <Panel title={`Blocked (${d.blocked.length})`} icon={ShieldBan} testid="blocked-list">
        <div className="px-2 py-2">{!d.blocked.length ? <Empty title="No blocked members" hint="Blocked members' chat messages are hidden for you." /> : d.blocked.map((m) => <MemberRow key={m.address} m={m} />)}</div>
      </Panel>
    </div>
  );
};

export function Leaderboard() {
  const { config } = useApp();
  return (
    <div className="mx-auto max-w-[900px] px-4 lg:px-8 py-10" data-testid="leaderboard-page">
      <PageHead kicker="Leaderboard" title="Top traders">Ranked purely from indexed on-chain swap events. HIVEVORA does not display profit claims or private data — only public addresses and voluntary aliases.</PageHead>
      <TopTraders pool={config.hive_pool || config.default_pool} compact={false} />
    </div>
  );
}

export function Community() {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/chat/channels").then((r) => setG(r.data)).catch(() => setG(null)); }, []);
  return (
    <div className="mx-auto max-w-[1300px] px-4 lg:px-8 py-10" data-testid="community-page">
      <PageHead kicker="Community" title="HIVEVORA Chat Wall">Talk with the hive, find members, add friends and manage blocks.</PageHead>
      <div id="chat" className="mb-8" data-testid="community-chat"><ChatWall /></div>
      <Tabs defaultValue="members">
        <TabsList className="mb-5 bg-black/40 border border-white/10 flex-wrap h-auto justify-start">
          <TabsTrigger value="members" data-testid="community-tab-members" className="gap-1.5 data-[state=active]:bg-lime data-[state=active]:text-black"><Search className="h-3.5 w-3.5" /> Members</TabsTrigger>
          <TabsTrigger value="network" data-testid="community-tab-network" className="gap-1.5 data-[state=active]:bg-lime data-[state=active]:text-black"><Users className="h-3.5 w-3.5" /> Friends & blocked</TabsTrigger>
        </TabsList>
        <TabsContent value="members"><MemberSearch /></TabsContent>
        <TabsContent value="network"><MyNetwork /></TabsContent>
      </Tabs>
      <Panel title="Community guidelines" icon={ShieldCheck} className="mt-6" testid="community-guidelines">
        <ul className="p-5 space-y-3 text-sm text-slate-300">{(g?.guidelines || []).map((x) => <li key={x} className="flex gap-2"><span className="hex h-2 w-2 bg-lime mt-1.5 shrink-0" />{x}</li>)}</ul>
      </Panel>
    </div>
  );
}
